import React from "react";

import TestFcrRteInitialForm from "./TestFcrRteInitialForm";
import TestFcrRtePlanningsForm from "./TestFcrRtePlanningsForm";
import { InitialData } from "./types";
import { FieldValues } from "react-hook-form";

const TestFcrRte: React.FC = () => {
  const [initialData, setInitialData] = React.useState<InitialData | null>(null);

  const handleInitialSubmit = (data: InitialData) => {
    setInitialData(data);
  };

  return !initialData ? (
    <TestFcrRteInitialForm onSubmit={handleInitialSubmit as (data: FieldValues) => void} />
  ) : (
    <TestFcrRtePlanningsForm initialData={initialData} />
  );
};

export default TestFcrRte;
